import React from "react"

const VideoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 sm:p-6"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl mx-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button - Better positioned for mobile */}
        <button
          onClick={onClose}
          className="absolute -top-10 sm:-top-12 right-0 text-white hover:text-gray-300 transition-colors z-10 p-2"
          aria-label="Close"
        >
          <svg
            className="w-6 h-6 sm:w-8 sm:h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Video Container */}
        <div className="relative bg-gray-900 rounded-lg sm:rounded-xl overflow-hidden shadow-2xl">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/fcvQ8JMwa3I?autoplay=1&rel=0"
              title="Product Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Optional: Swipe down hint for mobile */}
        <div className="mt-4 text-center text-white/60 text-sm sm:hidden">
          Tap outside to close
        </div>
      </div>
    </div>
  )
}

export default VideoModal
